import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

const PersonalInfo = () => {
	const [selected, setSelected] = useState("");

	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div class="edit-btn back">
										<Link to="/">
											<div class="nav-anchor">
												<i class="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<h5 class="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
										Personal Info
									</h5>
								</div>
								<form>
									<div className="row">
										<div className="form-group col-lg-6">
											<input
												type="text"
												className="form-control"
												id="firstName"
												placeholder=" First Name"
											/>
										</div>
										<div className="form-group col-lg-6">
											<input
												type="text"
												className="form-control"
												id="lastName"
												placeholder=" Last Name"
											/>
										</div>
									</div>
									<div className="form-group col-lg-12">
										<input
											type="email"
											className="form-control"
											id="email"
											placeholder="Enter email"
										/>
									</div>
									<div className="form-group col-lg-12">
										<input
											type="tel"
											className="form-control"
											id="phone"
											placeholder=" phone number"
										/>
									</div>
									<div className="form-group col-lg-12 position-relative">
										<input
											type="text"
											className="form-control"
											id="phone"
											placeholder="Address"
										/>
										<div className="position-wrapper d-flex align-items-center gap-4 position-absolute right-0 ">
											<label className="custom-checkbox">
												<input
													type="checkbox"
													name="location"
													value="home"
													checked={selected === "home"}
													onChange={() => setSelected("home")}
												/>
												<span className="checkbox-check"></span>
												<h5>Home</h5>
											</label>
											<label className="custom-checkbox">
												<input
													type="checkbox"
													name="location"
													value="office"
													checked={selected === "office"}
													onChange={() => setSelected("office")}
												/>
												<span className="checkbox-check"></span>
												<h5>Office</h5>
											</label>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-lg-4">
											<input
												type="text"
												className="form-control"
												id="phone"
												placeholder=" City"
											/>
										</div>
										<div className="form-group col-lg-4">
											<input
												type="text"
												className="form-control"
												id="phone"
												placeholder="State"
											/>
										</div>
										<div className="form-group col-lg-4">
											<input
												type="number"
												className="form-control"
												id="phone"
												placeholder=" Zip Code "
											/>
										</div>
									</div>
									<Link
										class="btn wrapper-btn-main mb-5 log-in mt-3 level-7 primary-regular-font text-decoration-none"
										href="/contactus/signin.php"
									>
										<span class="bg-wrapper ">Edit</span>
									</Link>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PersonalInfo;
